import React, { Component } from "react";
import {
    useHistory,useLocation,withRouter
} from "react-router-dom";
import axios from "axios";
import ConsoleHelper from "./ConsoleHelper";

 class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedInUser: null,
    };
    let sessionID= sessionStorage.getItem('COOKIE');
      //console.log(sessionStorage)
    axios
        .get(`getLoggedUserName?JSESSIONID=${sessionID}`)
      .then((response) => {
        console.log(
          "=== LOG_1 === Inside componentDidMount %s with data and session id as %s ",
          "Header",
          response.data,
        );
        this.setState({ loggedInUser: response.data });
          sessionStorage.setItem('loggedUserStorage', response.data);
      })
      .finally(() => {
          if(this.state.loggedInUser=='') {
              this.props.history.push({
                  pathname: `/`
              });
          }
      })
      .catch((error) => {
        console.log("GOT ERROR HERE for Get LoggedIn User", error);
      });
  }

  componentDidMount() {}

  render() {
    console.log(
      "=== LOG_2 === Inside render %s with data ",
      "Header",
      this.state
    );
    return (
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <a href="#" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src="assets/images/logo-dark-sm.png"
                    alt=""
                    height="22"
                  />
                </span>
                <span className="logo-lg">
                  <img src="assets/images/logo-dark.png" alt="" height="18" />
                </span>
              </a>

              <a href="#" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src="assets/images/logo-light-sm.png"
                    alt=""
                    height="22"
                  />
                </span>
                <span className="logo-lg">
                  <img src="assets/images/logo-light.png" alt="" height="18" />
                </span>
              </a>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars"></i>
            </button>
          </div>

          <div className="d-flex">
            <div className="dropdown d-inline-block log_account">
              <div
                className="btn header-item waves-effect d-flex align-items-center"
                id="page-header-user-dropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div className="text-left mr-2">
                  <p>{this.state.loggedInUser}</p>
                </div>
                <i className="fa fa-chevron-down"></i>
              </div>
              <div className="dropdown-menu dropdown-menu-right">
                <a className="dropdown-item" href="/logout">
                  <i className="uil uil-sign-out-alt font-size-16 align-middle mr-1 text-muted"></i>
                  <span className="align-middle" key="t-sign-out">
                    Sign out
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default withRouter(Header);
